"use client";

import { useEffect, type RefObject } from "react";

const MIN_HEADER_OFFSET = 88;

type SyncHeaderOffsetProps = {
  targetRef: RefObject<HTMLElement | null>;
};

export function SyncHeaderOffset({ targetRef }: SyncHeaderOffsetProps) {
  useEffect(() => {
    const el = targetRef.current;
    if (!el) return;

    const sync = () => {
      const height = Math.max(MIN_HEADER_OFFSET, Math.ceil(el.getBoundingClientRect().height));
      document.documentElement.style.setProperty("--header-offset", `${height}px`);
    };

    sync();

    const observer = new ResizeObserver(sync);
    observer.observe(el);

    window.addEventListener("resize", sync);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", sync);
    };
  }, [targetRef]);

  return null;
}
